export class MachineStatus {
    machineName:string;
    machineType: string;
    barcode: string;
    processStep:string;
    startTimeStamp:Date;
    processRunTime:number;
    remGraphic:string;
    remMin?:number;
    endTime?:Date;
}